import type { Service } from '../types/content'

export const services: Service[] = [
  {
    title: 'UX/UI Design',
    degrees: 0,
    body: 'User Interface Design is the foundation of every great website and app. We help brands identify consumer needs and take an innovative approach to create premium interfaces that are easy to use and people enjoy spending time with.',
  },
  {
    title: 'Web Design',
    degrees: 72,
    body: "A website is core to any brand's online presence and often the first thing people notice about you. We help make this first impression count by creating simple yet modern designs that put you on par with any fortune 500 company and leave no questions unanswered on how your products & services are showering the market with value.",
  },
  {
    title: 'Web Development',
    degrees: 144,
    body: 'Great web development is key to making websites, landing pages and web apps more functional, responsive and satisfying to interact with. We blur the lines between design and code, using technologies like Webflow, ThreeJS, GSAP and custom code to build infrastructure that is ment to last, easy to expand and stress free to navigate – without needing us ever again.',
  },
  {
    title: 'Brand Identity',
    degrees: 216,
    body: "Your visual identity is the one and everything that helps people recognize your company ... as you. It's a composition of names, logos, colors, fonts, visual graphics, words and so much more. We help you express this identity visually by carefully designing these elements with their meaning and purpose in mind - much like a well-fitting outfit. By creating harmony and patterns in design we help people recognize your brand with ease and be reminded of the same message over and over again – taking you one step closer to creating meaningful brand impact.",
  },
  {
    title: '3D Design',
    degrees: 288,
    body: "3D is here to give your brand a unique style and make people feel how great and exciting your products really are. If your competition is already doing it, it's probably because they're leaving their audience stunned with their mouths wide open – the good news is, you can too. By creating a unique visual style and assets that align with your brand's message, you can unleash 3D's superpower to create mind-blowing interactivity at people's fingertips and evoke a rush of emotion that burns into their brain and comes back every time they see your brand again.",
  },
]
